var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"prescriber"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('pages.memorial.edit')))]),_vm._v(" "),_c('b-container',[_c('ajax-edit',{attrs:{"name":_vm.name,"uri":_vm.uri,"id":_vm.id,"additionnal-route":_vm.additionnalRoute,"config":{ headers: { 'Content-Language': _vm.$translation.getLocale() } }}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b46cb0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Memorial/edit.vue
// module id = 878
// module chunks = 1